<!-- Copyright 2019, Nathan Lecompte -->

<template>
    <a class="res-item n-res-item" :href="item.url" rel="noopener noreferrer" :title="item.title">
        <img v-if="item.img" :src="item.img" :alt="item.title"/>
        <div class="n-res-info">
            <h2>{{ item.title }}</h2>
            <p>{{ item.desc }}</p>
            <span>
                <img :src="item.icon" alt="favicon"/> {{ item.url }} — {{ item.engine }}
            </span>
        </div>
    </a>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
	}
}
</script>

<style>
/* News search results */
.n-res {
	max-width: calc(50% + 150px)
}

/* News result */
.n-res-item {
	display: flex !important;
	padding: 4px !important
}
.n-res-item img {
	width: 100%;
	height: 100%;
	min-width: 150px;
	max-width: 150px;
	max-height: 150px;
	border-radius: 2px;
	align-self: center
}

/* News result > Info */
.n-res-info {
	margin: 15px 20px 25px 20px;
	width: calc(100% - 190px)
}

/* Media queries (mobile/responsive) */
@media (max-width: 1100px) {
	.n-res {
		max-width: 100%;
		margin: 0
	}
}
@media (max-width: 600px) {
	.n-res-item {
		display: block;
		padding: 20px 20px 4px
	}
	.n-res-item img {
		display: block;
		margin: 0 0 20px 0;
		min-width: 100%;
		max-height: 100%
	}
	.n-res-info {
		margin: 0 10px 20px 10px;
		width: calc(100% - 20px)
	}
	.n-res-info img {
		display: inline
	}
}
</style>